"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeAutocomplete = void 0;
const react_1 = __importStar(require("react"));
const attribute_autocomplete_styles_1 = require("./attribute-autocomplete.styles");
const localization_1 = require("../../../../../../localization");
const AttributeAutocomplete = ({ options, selected = '', resetKey, className, isDisabled, isLoading, moreItemsLoading, hasNextPage, allowCreation = false, resetSearchOnSelect, keepOpenOnSelect, preserveInputOnSelect, onSelect, onLoadMore, onSearch, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const autocompleteKey = (0, react_1.useMemo)(() => `${resetKey !== null && resetKey !== void 0 ? resetKey : ''}-${selected}`, [resetKey, selected]);
    const handleLoadMore = (0, react_1.useCallback)(() => Promise.resolve(onLoadMore === null || onLoadMore === void 0 ? void 0 : onLoadMore()), [onLoadMore]);
    const handleSelect = (0, react_1.useCallback)((attributeName) => {
        onSelect(attributeName);
        if (resetSearchOnSelect) {
            void (onSearch === null || onSearch === void 0 ? void 0 : onSearch(''));
        }
    }, [onSearch, onSelect, resetSearchOnSelect]);
    return (react_1.default.createElement(attribute_autocomplete_styles_1.StyledAttributeAutocomplete, { key: autocompleteKey, className: className, options: options, selected: selected, isDisabled: isDisabled, isLoading: isLoading, moreItemsLoading: moreItemsLoading, hasNextPage: hasNextPage, allowCreation: allowCreation, disableCloseOnSelect: keepOpenOnSelect, preserveInputOnSelect: preserveInputOnSelect, placeholder: t({ key: allowCreation ? 'SEARCH_OR_CREATE_ATTRIBUTE' : 'SEARCH' }), noOptionsText: t({ key: 'NO_DATA_AVAILABLE' }), onChange: handleSelect, onLoadMore: onLoadMore ? handleLoadMore : undefined, onSearch: onSearch }));
};
exports.AttributeAutocomplete = AttributeAutocomplete;
exports.default = exports.AttributeAutocomplete;
